export const save = (cfclick) => {
  localStorage.setItem('cfclick', cfclick);
};

export const remove = () => {
  localStorage.removeItem('cfclick');
};

export const get = () => localStorage.getItem('cfclick');
